import Home from "../../../jsx/components/Dashboard/Home";

const HomeWrapper = () => {
  return <Home />;
};

export default constore(HomeWrapper);
